import React from 'react';
import { supportingControl } from '../../data/site';
export function SupportingControl() {
  return <section aria-labelledby="control-heading" className="border-b border-line bg-cream" data-id="element-254" data-mp="1yxf4r4zl0pcm">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-24" data-id="element-255" data-mp="23ws0kf8fl6rc">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,0.7fr)_minmax(0,1.3fr)] lg:gap-16" data-id="element-256" data-mp="27ywt1an57xce">
          <div data-id="element-257" data-mp="27wk4ufqskqqw">
            <p className="micro-label text-[9px] text-gold-600" data-id="element-258" data-mp="2cy9crmipwoar">The control underneath</p>
            <h2 id="control-heading" className="mt-4 font-display text-[26px] font-semibold leading-[1.15] tracking-[-0.03em] text-charcoal-700 sm:text-[30px]" data-id="element-259" data-mp="2hx2szmpe2tem">
              Hands-free where it should be. Controlled where it matters.
            </h2>
            <p className="mt-4 text-[14px] leading-relaxed text-charcoal-500" data-id="element-260" data-mp="2vohdxz2ux4ob">
              KeyTurn monitors, listens, maps and recommends in the background. Material changes are
              always reviewable, attributable and reversible.
            </p>
          </div>

          <dl className="grid gap-x-12 sm:grid-cols-2" data-id="element-261" data-mp="2dcg0d5obr7n8">
            {supportingControl.map(item => <div key={item.title} className="border-t border-line py-4" data-id="element-262" data-mp="29bmba8z5bmsr">
                <dt className="text-[14px] font-semibold text-charcoal-700" data-id="element-263" data-mp="24aymltye3i1p">{item.title}</dt>
                <dd className="mt-1.5 text-[13px] leading-relaxed text-charcoal-500" data-id="element-264" data-mp="1zcnb7esg4zhd">{item.body}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}